<template>
    <el-container>
        <el-header class="clearfix" height="60px">
            <div class="index-box"><a href="javascript:;" @click="$util.goTo('/index/index')">返回首页</a></div>
            <div class="portrait-box" style="cursor:pointer;">
                <!-- <img v-if="head_portrait" :src="baseUrl + head_portrait" @click="$util.goTo('/user/info')"> -->
                <img  src="../../assets/img/touxiang.png" @click="$util.goTo('/user/info')">
				<!-- <el-button class="form_button" type="primary" @click="singlePrint" icon="el-icon-printer">单个打印</el-button> -->
                <span class="m-l-10">{{account_name}}</span>
                <span class="message-box" @click="$util.goTo('/user/message')"><i v-if="message_count>0"></i></span>
                <span style="display: inline-block;line-height: 32px;margin-left: 10px;">
                 <el-button type="primary" style="height: 28px;margin: 0 10px;padding:0 2px;line-height: 28px;" @click="logOutBtn">退出</el-button>
                </span>
            </div>
        </el-header>
        <el-aside width="200px">
            <div class="logo-box" style="padding-bottom: 35px;">
                <a href="javascript:;" @click="$util.goTo('/index/index')" style="box-sizing: border-box;">
					<img src="../../assets/img/logo.png" style="width: 80%;height:80%;">
				</a>
            </div>
            <el-menu :default-active="$route.path" router unique-opened ref="sideMenu" @open="openSubMenu">
                <template v-for="(item,index) in menus">
                  
					<el-menu-item v-if="item.children.length ==0" :key="index" :index="item.url" :class="{'is-active':ppShow(item.children,$route.path)}">
					 
					    <span slot="title">{{item.name}}</span>
					</el-menu-item>
					<el-submenu v-else :index="String(item.id)">
					    <template slot="title">
							
						<span slot="title">{{item.name}}</span></template>
					    <el-menu-item v-for="(child, idx) in item.children" :key="idx" :index="child.url">{{child.name}}</el-menu-item>
					</el-submenu>
                </template>
            </el-menu>
			<iframe id="frame" src="../../assets/preview.html" frameborder="0" ref="iframe" style="display: none;"></iframe>
        </el-aside>
        <el-main>
            <router-view></router-view>
        </el-main>
		<form id="form1">
		        <table  width="300" id="tb01" bgcolor="#CCFFCC" style=" border-collapse: collapse">
		            <tr>
		                <td colspan="3" align="center" v-if="orderMessageData.order"  id="mtb001"><font face="黑体" color="#FF0000" ><u>&nbsp;桌台:{{orderMessageData.order.tableCode}}&nbsp;</u></font></td>
		            </tr>
					<tr>
					    <td colspan="3" align="center" v-if="orderMessageData.order"   id="mtb001"><font face="黑体" >{{orderMessageData.order.updatedate?orderMessageData.order.updatedate:orderMessageData.order.createdate}}</font></td>
					</tr>
					<tr v-if="orderMessageData.order && orderMessageData.order.orderStatus==3" >
					    <td colspan="3" align="center"    id="mtb001"><font face="黑体" >{{orderMessageData.order.orderStatusText}}</font></td>
					</tr>
					
		        </table>
				<div class="" v-if="orderMessageData.order">
					<div class="" v-for="(item,index) in orderMessageData.order.listDetail" :key="index">
						备注{{index+1}}:{{item.cookName}}({{item.remark}})
					</div>
					<div class="" v-for="(item,index) in orderMessageData.order.addDetail" :key="index">
						备注{{index+1}}:{{item.cookName}}({{item.remark}})
					</div>
					<div class="" v-for="(item,index) in orderMessageData.order.deleteDetail" :key="index">
						备注{{index+1}}:{{item.cookName}}({{item.remark}})
					</div>
				</div>
		        <table  v-if="orderMessageData.order && orderMessageData.order.orderStatus !=3" width="300" height="106" cellspacing="0" bgcolor="#CCFFFF" style="border-collapse: collapse; table-layout: fixed;">
					<tr>
		                <td width="66" height="16" ><font color="#0000FF">名称</font></td>
		                <td width="51" height="16" ><font color="#0000FF">数量</font></td>
		                <td width="51" height="16" ><font color="#0000FF">价格</font></td>
		            </tr>
					
					<tr v-for="(item,index) in orderMessageData.order.listDetail" :key="index">
					    <td width="66" height="16" >{{item.cookName}}</td>
					    <td width="80" height="12">{{item.count}}</td>
					    <td width="51" height="12" >{{item.cookPrice}}</td>
					</tr>
		            <tr v-for="(item,index) in orderMessageData.addDetail" :key="index">
		                <td width="66" height="16" >{{item.cookName}}<sub>{{item.statusText}}</sub></td>
		                <td width="80" height="12">{{item.count}}</td>
		                <td width="51" height="12" >{{item.cookPrice}}</td>
		            </tr>
		           <tr v-for="(item,index) in orderMessageData.deleteDetail">
		               <td width="66" height="16" >{{item.cookName}}<sub>{{item.statusText}}</sub></td>
		               <td width="80" height="12">{{item.count}}</td>
		               <td width="51" height="12" >{{item.cookPrice}}</td>
		           </tr>
		        </table>
		    </form>
    </el-container>
</template>
<script>
// import { Button, Select, } from 'element-ui';
import menu_list from '@/assets/js/menu.js';
import bus from '@/assets/js/defined.js'
import  PrintAccount from '@/assets/js/doPrint.js'
import getLodop from '@/assets/js/lodop.js'
export default {
    name: 'layout',
    data(){
        return {
            menus: [],
            account_name:'',
            baseUrl:this.$client.IMG_URL,
            head_portrait:'',
            //menus: [],
            auth_list:[],
            active_route: '', //$route.path,
            side_height: 0,
            hasMessage:false,
            message_count:0,
			orderMessageData:{}
        }
    },
    created(){

        var _this = this;
        var menu_list = localStorage.getItem('menu_list');
        this.menus = JSON.parse(menu_list);
        console.log(this.menus,"this.menus我得菜单");
        this.account_name = localStorage.getItem('username');
        this.head_portrait = localStorage.getItem('head_portrait');

       // _this.getMessage();

        var wsServer = this.$client.ORDER_URL;
        var websocket = new WebSocket(wsServer);
        websocket.onopen = function(evt) {
            console.log("Connected to WebSocket server.");
            websocket.send('getfd');
			heartCheck.start();
            console.log(evt)
        };
		var heartCheck = {
		        timeout: 60000,//60s
		        timeoutObj: null,
		        reset: function(){
		            clearInterval(this.timeoutObj);
		            this.start();
		        },
		        start: function(){
		            this.timeoutObj = setInterval(function(){
		                if(websocket.readyState==1){
		                    websocket.send("HeartBeat");
		                }
		            }, this.timeout)
		        }
		    }

   //      websocket.onclose = function(evt) {
   //          console.log("Disconnected");
			// // reconnect()
   //      };
        websocket.onmessage = function(evt) {
            // console.log('Retrieved data from server: ' + evt.data);
			
			
            var fdObj = JSON.parse(evt.data);
			 //console.log(fdObj,"订房")
            if(fdObj.funBody){
               
				_this.orderMessageData=fdObj.funBody
				console.log(_this.orderMessageData,"订单");
                // _this.bindTheFd(fdObj.fd)
				setTimeout(()=>{
					_this.singlePrint()
				},500)
            }else if(fdObj.event) {
                var event = fdObj.event;
                console.log(event);
                // _this.getMessage();
                _this.speckText('您有新的订单，请注意查看！');
            }
        };
        websocket.onerror = function(evt, e) {
            console.log('Error occured: ' + evt.data);
        };
    },
    methods: {
		//单单
		singlePrint() {
			let LODOP = getLodop();
			LODOP.PRINT_INIT("订单");               //首先一个初始化语句 
			// LODOP.ADD_PRINT_TEXT(0, 0, 100, 20, "文本内容一");//然后多个ADD语句及SET语句 
			LODOP.SET_PRINT_STYLE("FontSize", 18);
			LODOP.SET_PRINT_STYLE("Bold", 1);
			// LODOP.ADD_PRINT_TEXT(50, 231, 260, 39, "打印页面部分内容");
			LODOP.ADD_PRINT_HTM('0.02cm', '0.02cm','100%','99%',document.getElementById("form1").innerHTML);
				LODOP.PRINT();
			//LODOP.PREVIEW();
		},
        speckText(str) {
            var url= this.$client.IMG_URL + '/mp3/tx.mp3';
			// var url= "http://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&per=0&spd=6&text=" + encodeURI(str);
            var n = new Audio(url);
            n.src = url;
            n.play();
			console.log('test');
        },
        bindTheFd(fd){
            var _this = this;
            this.$client.post('/adminapi/admin/savefd', {fd:fd}, function(res,message){

            },function(res){

            });
        },
        getMessage(){
            var _this = this;
            this.$client.post('/ws/biz/order', {}, function(res,message){
				console.log(res,"拉取新增订单")
                _this.message_count = res.message_count;
                bus.$emit('msgCountChange',res.message_count);
            },function(res){

            });
        },
        ppShow(list,path){
            for (let key in list) {
                if(list[key].path==path)
                    return true
            }
            return false;
        },
        handleSelect(key, keyPath) {

        },
        logOutBtn(){
            var _this = this;
            this.$confirm('确定要退出登录？', "", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        iconClass:"icon-logout el-icon-delete",
                        customClass:"my-confirm-box",
                        center: true,
                    })
                    .then(() => {
                localStorage.setItem('token','');
                _this.$util.goTo('/login');
        })
        .catch(() => {});
        },
        openSubMenu(){
            setTimeout(()=>{
                this.side_height = this.$refs.sideMenu.$el.offsetHeight;
        },1000);
        }
    },
    mounted() {
        bus.$on("menuChange", (menu_list) => {
            this.menus = menu_list;
        });
        bus.$on("headChange", (head_img) => {
            this.head_portrait = head_img;
        });
        bus.$on("countChange", (get_count) => {
            this.message_count = get_count;
             bus.$emit('msgCountChange',get_count);
         });
		 
    }
}
</script>

